import { Component, OnInit } from "@angular/core";
import { IdentityService } from "src/app/security/identity.service";
import { UIControlService } from "src/app/shared/uicontrol.service";
import { Observable, from } from "rxjs";
import { AngularFireStorage } from "@angular/fire/storage";

@Component({
  selector: "app-header-bar",
  templateUrl: "./header-bar.component.html",
  styleUrls: ["./header-bar.component.scss"]
})
export class HeaderBarComponent implements OnInit {
  uVuyoImage$: Observable<string>;

  constructor(
    public identity: IdentityService,
    private ui: UIControlService,
    private firebaseStorage: AngularFireStorage
  ) {}
  public ngOnInit(): void {
    this.uVuyoImage$ = from(
      this.firebaseStorage.storage
        .ref("uvuyo_Logo_cropped.png")
        .getDownloadURL()
    );
  }

  public toggleSideNavBar() {
    this.ui.sideNavOpen$.next(!this.ui.sideNavOpen$.getValue());
  }
}
